import { useLayoutEffect } from 'react';

import { useThemeEnabled } from '@apps/web/hooks/use_theme_enabled';
import { themeStore } from '@apps/web/lib/theme_store';

export function ThemePolicy() {
    const isEnabled = useThemeEnabled();

    useLayoutEffect(() => {
        // Keep the prepainted choice while an uncached org is loading.
        if (isEnabled !== undefined) {
            themeStore.setEnabled(isEnabled);
        }
    }, [isEnabled]);

    useLayoutEffect(() => () => themeStore.setEnabled(false), []);

    return null;
}
